import React from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "semantic-ui-react";

import Popper from "components/Popper";

function AddClientButton({ isOpen, text, onClick, onClose, children }) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Icon color="grey" name="user" />
      {text}

      <Popper
        on="click"
        open={isOpen}
        flowing
        position="right center"
        onClose={(event) => {
          // Clicking button in the confirmation modal should not close the popup
          if (
            event.target.closest("div.ui.small.modal.visible.active") ||
            event.target.closest("#create_new_client_modal")
          ) {
            return;
          }
          onClose();
        }}
        style={{ zIndex: "1000" }}
        trigger={
          <Button id="add-client-button" icon>
            <Icon name="add" style={{ fontSize: "12pt" }} />
          </Button>
        }
      >
        <div id="add-client-popup" data-test="add-client-dropdown-popup">
          {children(onClose)}
        </div>
      </Popper>
    </div>
  );
}

AddClientButton.defaultProps = {
  children: () => {},
  isOpen: false,
  text: "Add Client",
  onClick: () => {},
  onClose: () => {},
};

AddClientButton.propTypes = {
  isOpen: PropTypes.bool,
  text: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.func,
};

export default AddClientButton;
